import React from 'react';
import { ProjectRubrica } from '../../../shared/interfaces/rubrica';
import './styles/form-rubrica-section.css';

interface RubricasSectionProps {
  projectRubricas: ProjectRubrica[];
  onOpenModal: () => void;
  isEditor: boolean;
  isLoading: boolean;
  formatCurrency: (value: number) => string;
  projectValue: number;
  calculateTotalFromRubricas: (rubricas: ProjectRubrica[]) => number;
}

export default function RubricasSection({
  projectRubricas,
  onOpenModal,
  isEditor,
  isLoading,
  formatCurrency,
  projectValue,
  calculateTotalFromRubricas
}: RubricasSectionProps) {
  
  const rubricasTotalValue = calculateTotalFromRubricas(projectRubricas);
  const hasRubricas = projectRubricas.length > 0;
  
  return (
    <div className="container-form__rubricas">
      <div className="rubricas-section">
        <div className="rubricas-section__header">
          <div className="rubricas-section__title-wrapper">
            <h3 className="rubricas-section__title">Rubricas do Projeto</h3>
            <span className="rubricas-section__subtitle">
              Defina os valores por categoria de despesa
            </span>
          </div>
          <button
            type="button"
            onClick={onOpenModal}
            className="rubricas-section__button"
            disabled={!isEditor || isLoading}
          >
            <span className="rubricas-section__button-icon">+</span>
            {hasRubricas ? 'Editar Rubricas' : 'Adicionar Rubricas'}
          </button>
        </div>
        
        {hasRubricas ? (
          <div className="rubricas-section__content">
            <div className="rubricas-list">
              {projectRubricas.map((rubrica, index) => (
                <div key={`rubrica-${rubrica.rubricaId}-${index}`} className="rubrica-item">
                  <div className="rubrica-item__left">
                    <div className="rubrica-item__badge">
                      {index + 1}
                    </div>
                    <div className="rubrica-item__info">
                      <span className="rubrica-item__name">
                        {rubrica.rubrica?.name || `Rubrica ${rubrica.rubricaId}`}
                      </span>
                      {rubrica.rubrica?.description && (
                        <span className="rubrica-item__description">
                          {rubrica.rubrica.description}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="rubrica-item__right">
                    <div className="rubrica-item__value">
                      {formatCurrency(rubrica.valor)}
                    </div>
                    <div className="rubrica-item__percentage">
                      {rubricasTotalValue > 0 
                        ? `${((rubrica.valor / rubricasTotalValue) * 100).toFixed(1)}%`
                        : '0%'
                      }
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="rubricas-summary">
              <div className="rubricas-summary__header">
                <h4 className="rubricas-summary__title">Resumo Financeiro</h4>
              </div>
              <div className="rubricas-summary__content">
                <div className="rubricas-summary__row">
                  <span className="rubricas-summary__label">Número de Rubricas:</span>
                  <span className="rubricas-summary__value">
                    {projectRubricas.length}
                  </span>
                </div>
                <div className="rubricas-summary__row">
                  <span className="rubricas-summary__label">Valor do Projeto:</span>
                  <span className="rubricas-summary__value">
                    {formatCurrency(projectValue)}
                  </span>
                </div>
                <div className="rubricas-summary__row">
                  <span className="rubricas-summary__label">Maior Valor:</span>
                  <span className="rubricas-summary__value">
                    {projectRubricas.length > 0 
                      ? formatCurrency(Math.max(...projectRubricas.map(r => r.valor)))
                      : formatCurrency(0)
                    }
                  </span>
                </div>
                <div className="rubricas-summary__row">
                  <span className="rubricas-summary__label">Total das Rubricas:</span>
                  <span className="rubricas-summary__value">
                    {formatCurrency(rubricasTotalValue)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="rubricas-section__empty">
            <div className="rubricas-empty__icon">
              💰
            </div>
            <div className="rubricas-empty__content">
              <h4 className="rubricas-empty__title">
                Nenhuma rubrica configurada
              </h4>
              <p className="rubricas-empty__description">
                As rubricas permitem organizar os gastos do projeto por categoria.
                <br />
                Clique em "Adicionar Rubricas" para começar.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
